import SortableDataTableControl from './control/SortableDataTable.control';
import SectionedListControl from './control/SectionedList.control';
import highLightEventDispatcher from './highlightEvent.dispatcher';
import schoolChartControlConfig from './control/BarChartControl/SchoolChart.config';
import SideBarControl from './control/sideBar.control';

const controllers = {
	SortableDataTable: { 
		controlClass: SortableDataTableControl,
		config:{
			styleTR:(node,row)=>{
				node.style.backgroundColor = row.gradeColor;
				node.style.color = row.gradeContrast;
			},
			rowIndex:'content',
			
		}
	 },
	SectionedWinnerListControl: {
		controlClass: SectionedListControl, config: {
			sortIndex: 'region',
			listElementParser: function (listElement) { 
				let li = document.createElement('li');
				let highlight = highLightEventDispatcher.getHighlight('school',listElement.uid);
				if(highlight){
					li.setAttribute('highlight',true);
				}
				li.innerText = `${listElement.name} - ${listElement.rank}`; 
				li.setAttribute('el-value',listElement.uid);
				li.setAttribute('el-key','school');
				li.setAttribute('sec-key','region');
				li.setAttribute('sec-value',listElement.region)
				return li;
			},
			listParser: function (data) {
				return data.data.row.winners;
			},
			onClick:function(section,value,sectionArr = null){
				if(sectionArr){
					let highLightRegion = highLightEventDispatcher.toggleHighLight(section,value);
					let highLightFunction;
					if(highLightRegion){
						highLightFunction = highLightEventDispatcher.addHighlight.bind(highLightEventDispatcher);
					}else{
						highLightFunction = highLightEventDispatcher.removeHighlight.bind(highLightEventDispatcher);
					}
					for(var i = 0;i<sectionArr.groupObj.length;i++){
						highLightFunction('school',sectionArr.groupObj[i].name);
					}
					
				}else{
					highLightEventDispatcher.toggleHighLight(section,value);
				}
				
			},
			updateDispatchers:[highLightEventDispatcher],
		}
	},
	SectionedSchoolListControl: {
		controlClass: SectionedListControl, config: {
			sortIndex: 'system',
			listElementParser: function (listElement) {
				let li = document.createElement('li');
				let highlight = highLightEventDispatcher.getHighlight('school',listElement.uid);
				li.innerText = `${listElement.school}`;
				if(highlight){
					li.setAttribute('highlight',true);
				}
				li.setAttribute('el-value',listElement.uid);
				li.setAttribute('el-key','school');
				li.setAttribute('sec-key','system');
				li.setAttribute('sec-value',listElement.system);
				return li;
			},
			listParser: function (data) {
				return data.data.rows;
			},
			onClick:function(section,value,sectionObjs = null){
				if(sectionObjs){
					let grades = [];
					let {groupObj} = sectionObjs;
					for(let i = 0;i<groupObj.length;i++){
						
						let {grade} = groupObj[i];
						if(grades.indexOf(grade) === -1 ){
							grades.push(grade);
						}
					}
					highLightEventDispatcher.toggleHighLight(section,value,grades);
				}else{
					highLightEventDispatcher.toggleHighLight(section,value);
				}
				
			},
			groupSort:function(a,b){
				let lowerA =a.school.toLowerCase();
				let lowerB =b.school.toLowerCase();
	
				if(lowerA==lowerB){
					return 0;
				}
				if(lowerA<lowerB){
					return -1;
				}
				return 1;
			},

			updateDispatchers:[highLightEventDispatcher],
		}
	},
	SchoolChartControl: schoolChartControlConfig,
	SideBarControl:{
		controlClass:SideBarControl,
		config:{}
	},
};
export default controllers;
